export const WHITE = "WHITE";
export const YELLOW = "YELLOW";
